import { render } from "./BackgroundColors.vue?vue&type=template&id=691fa91e"
import script from "./BackgroundColors.vue?vue&type=script&lang=js"
export * from "./BackgroundColors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__